export default __webpack_public_path__ + "static/media/Logo-Horizontal-Normal.222e94f7.svg";